import { useEffect, useState } from "react";
import api from "../../lib/api";
import { eur, itDate } from "../../lib/constants";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { Search } from "lucide-react";

const MONTHS = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];
const mLabel = (k) => `${MONTHS[Number(k.slice(5, 7)) - 1]} ${k.slice(0, 4)}`;

export default function ExpensesSection({ supplierId }) {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [q, setQ] = useState("");
  const [data, setData] = useState({ items: [], by_month: {}, total: 0 });
  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/suppliers/${supplierId}/expenses?date_from=${from}&date_to=${to}&search=${encodeURIComponent(q.trim())}`).then((r) => setData(r.data)).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [supplierId, from, to, q]);

  return (
    <div className="space-y-4" data-testid="sec-spese">
      <div className="card-soft p-4">
        <div className="flex flex-wrap items-end gap-2">
          <div><Label className="text-xs">Dal</Label><Input data-testid="exp-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} /></div>
          <div><Label className="text-xs">Al</Label><Input data-testid="exp-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} /></div>
          <div className="relative flex-1 min-w-[200px]"><Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input data-testid="exp-search" className="pl-9" placeholder="Cerca per descrizione" value={q} onChange={(e) => setQ(e.target.value)} /></div>
          {(from || to || q) && <Button variant="ghost" size="sm" data-testid="exp-reset" onClick={() => { setFrom(""); setTo(""); setQ(""); }}>Azzera</Button>}
        </div>
        <p className="text-xs text-muted-foreground mt-2">Uscite segnate come pagate in Incassi → Uscite previste con questo fornitore. Ogni pagamento è contato una sola volta.</p>
      </div>
      <div className="grid lg:grid-cols-3 gap-4">
        <div className="card-soft p-4 h-fit" data-testid="exp-months">
          <p className="text-xs uppercase text-muted-foreground">Totale speso nel periodo</p>
          <p className="font-head text-3xl font-extrabold text-red-700 mb-3" data-testid="exp-total">{eur(data.total)}</p>
          {Object.entries(data.by_month).map(([k, v]) => (
            <div key={k} data-testid={`exp-month-${k}`} className="flex justify-between text-sm py-1.5 border-b border-border last:border-0"><span>{mLabel(k)}</span><span className="font-semibold">{eur(v)}</span></div>
          ))}
        </div>
        <div className="lg:col-span-2 space-y-2">
          {data.items.length === 0 ? <div className="card-soft p-8 text-center text-sm text-muted-foreground" data-testid="exp-empty">Nessuna spesa pagata registrata per questo fornitore.</div>
            : data.items.map((i) => (
              <div key={i.id} data-testid={`exp-row-${i.id}`} className="card-soft p-3 flex items-center gap-3">
                <div className="min-w-0 flex-1"><p className="text-sm font-medium truncate">{i.description || "Pagamento"}</p>
                  <p className="text-xs text-muted-foreground truncate">Pagato il {itDate(i.paid_date)}{i.notes ? ` · ${i.notes}` : ""}</p></div>
                <span className="font-head font-bold text-red-700">{eur(i.amount)}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
